// JoJo's Cookie Company - Homepage JavaScript

document.addEventListener('DOMContentLoaded', function() {
    // Mobile Menu Toggle
    const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
    const navMenu = document.querySelector('.nav-menu');
    
    if (mobileMenuToggle) {
        mobileMenuToggle.addEventListener('click', function() {
            navMenu.classList.toggle('active');
        });
    }
    
    // Email Popup Logic
    const emailPopup = document.getElementById('emailPopup');
    const popupClose = document.querySelector('.popup-close');
    const emailForm = document.getElementById('emailForm');
    
    // Show popup on exit intent (when mouse leaves viewport at top)
    let popupShown = false;
    document.addEventListener('mouseout', function(e) {
        if (!popupShown && !e.relatedTarget && e.clientY < 10) {
            showEmailPopup();
        }
    });
    
    // Also show after 30 seconds if not shown
    setTimeout(function() {
        if (!popupShown) {
            showEmailPopup();
        }
    }, 30000);
    
    function showEmailPopup() {
        if (emailPopup && !popupShown) {
            emailPopup.classList.add('active');
            popupShown = true;
            
            // Store in session storage to not show again this session
            sessionStorage.setItem('emailPopupShown', 'true');
        }
    }
    
    // Check if popup was already shown this session
    if (sessionStorage.getItem('emailPopupShown')) {
        popupShown = true;
    }
    
    // Close popup
    if (popupClose) {
        popupClose.addEventListener('click', function() {
            emailPopup.classList.remove('active');
        });
    }
    
    // Close popup on background click
    if (emailPopup) {
        emailPopup.addEventListener('click', function(e) {
            if (e.target === emailPopup) {
                emailPopup.classList.remove('active');
            }
        });
    }
    
    // Handle email form submission
    if (emailForm) {
        emailForm.addEventListener('submit', function(e) {
            e.preventDefault();
            
            const emailInput = emailForm.querySelector('input[type="email"]');
            const email = emailInput.value;
            
            // Here you would integrate with Mailchimp API
            // For now, just show success message and close
            alert('Thanks for joining! Use code WELCOME10 for 10% off your first order.');
            emailPopup.classList.remove('active');
            
            // You can add Mailchimp integration here:
            // fetch('YOUR_MAILCHIMP_ENDPOINT', {
            //     method: 'POST',
            //     body: JSON.stringify({ email: email }),
            //     headers: { 'Content-Type': 'application/json' }
            // });
        });
    }
    
    // Smooth scroll for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            const href = this.getAttribute('href');
            if (href !== '#' && document.querySelector(href)) {
                e.preventDefault();
                const target = document.querySelector(href);
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });
    
    // Add animation on scroll
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };
    
    const observer = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.opacity = '1';
                entry.target.style.transform = 'translateY(0)';
            }
        });
    }, observerOptions);
    
    // Observe cookie cards for scroll animations
    document.querySelectorAll('.cookie-card, .testimonial, .step').forEach(el => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(30px)';
        el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        observer.observe(el);
    });
});
